import React, {useContext, useState} from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, Row, Select} from 'antd';
import Colors from "../../../styles/Colors";
import { BiCheck, BiX } from "react-icons/bi";
import {PostInscripcionsContacte} from "../../../dao/inscripcions/PostInscripcionsContacte";
import {AuthContext} from "../../../config/AuthContext";
import {useParams} from "react-router-dom";
import locale from "antd/es/locale/es_ES";

interface PagadorModalProps {
    element: any; // Cambiado a tipo any para aceptar cualquier tipo de elemento
    visible: boolean;
    onClose: (value: boolean) => void;
    idInsc: string;
}

const AutoritzatModal: React.FC<PagadorModalProps> = ({ element, visible, onClose, idInsc }) => {
    const [form] = Form.useForm();

    const {isLoggedIn, userId, user, page, userDni, userCognom} = useContext(AuthContext);
    const {id_inscripcio} = useParams();

    async function handleSubmit () {
        let formData = form.getFieldsValue();
        formData = {...formData, pagador: 0, autoritzat: 1};
        //console.log("Form Data:", formData);
        await PostInscripcionsContacte((id_inscripcio === undefined ? idInsc : id_inscripcio)+"", page, formData);
        onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
        <Modal
            title="AUTORITZAT"
            visible={visible}
            onCancel={handleCancel}
            footer={[]}
            width={window.innerWidth < 768 ? "100%" : "70%"}

        >
            <Form form={form} initialValues={element} onFinish={handleSubmit}>
                <Row gutter={[16, 16]}>
                    <Col span={12}>
                        <Form.Item label="ID" name="id">
                            <Input disabled />
                        </Form.Item>
                        <Form.Item label="Nom" name="nom"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Cognoms" name="cognoms"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Telèfon" name="telefon"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Telèfon 2" name="telefon2">
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item label="Telèfon 3" name="telefon3">
                            <Input />
                        </Form.Item>
                        <Form.Item label="DNI" name="dni">
                            <Input />
                        </Form.Item>
                        <Form.Item label="Parentesc" name="parentesc"
                                   rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                            <Input />
                        </Form.Item>
                        <Form.Item label="Direcció" name="direccio">
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item wrapperCol={{offset: 0, span: 16}}>
                    <Button title={"Aceptar"} htmlType={"submit"} style={{backgroundColor: Colors.colors.color6}}
                    ><BiCheck/></Button>
                    {" "}
                    <Button title={"Cancelar"} style={{backgroundColor: Colors.colors.color1}}
                            onClick={handleCancel}><BiX/></Button>
                </Form.Item>
            </Form>
        </Modal>
        </ConfigProvider>
    );
};

export default AutoritzatModal;
